import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
import { ResponseFilterLicense, ResponseFilterRequirements } from '../../../../../interfaces/reports/reports';

@Component({
  selector: 'app-report-table-requests',
  templateUrl: './report-table-requests.component.html',
  styleUrls: ['./report-table-requests.component.css'],
})
export class ReportTableRequestsComponent implements OnInit {

  @Input() detailRequestsByFilter: ResponseFilterRequirements[] = []
  @Output() exportToExcel = new EventEmitter<any>();

  imagesStatus: Record<string, string> = {
    PENDIENTE: 'assets/img/atencion.png',
    EN_PROCESO: 'assets/img/espera.png',
    EN_CURSO: 'assets/img/espera.png',
    SOLICITUD_ANTECEDENTES: 'assets/img/espera.png',
    RECHAZADA: 'assets/img/rechazado.png',
    APROBADA: 'assets/img/aprobado.png',
    ELIMINADO: 'assets/img/rechazado.png',
    CANCELADA: 'assets/img/rechazado.png',
  };

  constructor(private orderPipe: OrderPipe) {
    this.detailRequestsByFilter = this.detailRequestsByFilter.slice();
    this.collectionToOrder = this.orderPipe.transform(this.detailRequestsByFilter, 'detailRequestsByFilter.id');

  }
  ngOnInit(): void {
  }

  formatStatus(status?: string) {
    if (status) {
      return status.toUpperCase().replace(/\s+/g, '_');
    }
    return '';
  }
  //  ------> sorting activities  <-------
  orderActivities: string = ''
  reverse: boolean = false;
  collectionToOrder: Partial<ResponseFilterLicense[]>;

  order: string = ''
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  //  ------> paginate activities  <-------

  public config: any = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: this.detailRequestsByFilter.length,
  };

  public maxSize: number = 30;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    previousLabel: '<',
    nextLabel: '>',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: 'You\'re on page',
  };

  export() {
    this.exportToExcel.emit();
  }
}
